// @ts-nocheck

import * as R from 'ramda';
import { CREATE_WEBHOOK, GET_WEBHOOKS, UPDATE_WEBHOOK } from '../actions/WebhookActions2';
import { reducerWrapper } from '../support/utils';
import type { WebhookActionPayload, WebhookReducer } from '../types/webhookTypes';
var INIT_STATE: WebhookReducer = {
  loading: true,
  error: null,
  data: [],
};

function Handler(state: WebhookReducer, action: WebhookActionPayload) {
  switch (action.type) {
    case GET_WEBHOOKS.response:
      return {
        loading: false,
        error: null,
        data: action.data,
      };

    case CREATE_WEBHOOK.response:
      return {
        loading: false,
        error: null,
        data: R.prepend(action.data, state.data),
      };

    case UPDATE_WEBHOOK.response:
      const idx = R.findIndex(R.propEq('id', action.data.id), state.data);
      return {
        loading: false,
        error: null,
        data: R.update(idx, action.data, state.data),
      };

    default:
      return state;
  }
}

const WebhooksReducer = reducerWrapper(INIT_STATE, Handler, {
  request: [GET_WEBHOOKS, CREATE_WEBHOOK, UPDATE_WEBHOOK],
  error: [GET_WEBHOOKS, CREATE_WEBHOOK, UPDATE_WEBHOOK],
  resetOn: ['APP_CHANGE'],
});
export default WebhooksReducer;
